export default __webpack_public_path__ + "static/media/dogs.bbf2902f.png";